<template>
  <div 
    class="accent-settings mb-2 pt-1" 
    :class="{'mobile-accent-settings': mobile, 'border-0' : searchModel === 'tavnit'}"
    >
    <small>{{hebrew ? 'הטעמה' : 'Accent'}}</small>
    <b-form-radio-group      
      v-model="selectedAccent"
      :options="accentOptions"
      class="radio-group"
      name="radio-options"
      stacked
    ></b-form-radio-group>
  </div>
</template>
<script>
  import { Actions } from "@/store/stateChanges"
  export default {
  name: "AccentSettings",
  data() {
    return {
      //onMount: true,
      accentOptions: [        
        { text: 'מלעיל ומלרע', value: 'returnall' },
        { text: 'מלרע', value: 'acc0' },
        { text: 'מלעיל', value: 'acc1' }
      ]
    }
  },
  mounted () {
    if (this.searchModel !== 'tavnit') {
      this.accentOptions.unshift({ text: 'הטעמה מותאמת למילת החיפוש', value: 'matchinput' })
    } 
  },
  methods: {
    clicked () {
      this.onMount = false
    }
  },
  computed: {
    hebrew: function () {
      return this.$settings.hebrew    
    },
    searchModel () {
      return this.$store.state.searchModel
    },    
    selectedAccent: {
      get () {
        return this.searchModel === 'tavnit' && this.$store.state.preSubmissionOptions.accent === 'matchinput' ? 'returnall' : this.$store.state.preSubmissionOptions.accent
      },  
      set (value) {
        this.$store.commit('SET_ACCENT',  value)
        //if (!this.mobile  && !this.onMount) 
        this.$store.dispatch(Actions.RUN_CHARUZIT)
      }
    },
    mobile () {
      return this.$mq === 'xs'
    }  
  }
}
</script>
<style  lang="scss">
  .accent-settings {
    border-top: 1px dashed #c8c8c8;
    &.mobile-accent-settings {      
      margin-top: 25px;
      border-top: 1px solid #c8c8c8;
      padding-top: 10px!important;
      small {        
        font-size: 18px;        
      }
      .radio-group {
        margin-top: 5px;
        box-shadow: 1px 1px 2px 0 rgba(0, 0, 0, 0.3);
        border: 1px solid #c2c2c2;
        border-radius: 2px;
        div {
          padding: 18px 14px;
          border-bottom: 1px solid #c8c8c8;
          min-height: 64px;
          font-size: 18px;
          .custom-control-label {
            display: block;
          }
          .custom-control-label:after, .custom-control-label:before {
            left: 0;
            right: auto;
            width: 24px;
            height: 24px;
            top: 1px;
          }
        }
      }
    }
  }
</style>